/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type PartnerIntent = (typeof PartnerIntent)[keyof typeof PartnerIntent];

export const PartnerIntent = {
  workwhile: "workwhile",
  walmart: "walmart",
  sams_club: "sams_club",
} as const;
